<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">Media sharing</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
  <bt-page-header title="Media sharing" subtitle="Links that share style media with people outside the company" icon="fa-solid fa-share-from-square">
    <button (click)="openCreateMediaShareLinkModal()">
      <i class="fa-solid fa-plus margin-right-small"></i>
      Create link
    </button>
  </bt-page-header>

  <div class="flex wrap gap margin-bottom-small">
    <div class="filter-chip" [ngClass]="!mediaShareLinkFilters.creationDate ? '' : 'selected'">
      @if (mediaShareLinkFilters.creationDate) {
        <div class="flex center hover" (click)="openCreationDateFilterModal()">
          <b class="margin-right-smallest">Creation Date:</b>
          {{ mediaShareLinkFilters.creationDate.from | date: 'dd-MM-yyyy' }} -
          {{ mediaShareLinkFilters.creationDate.to | date: 'dd-MM-yyyy' }}
        </div>
        <mat-icon (click)="cleanFilter('creationDate')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCreationDateFilterModal()">
          Creation Date
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!mediaShareLinkFilters.styleCodes || !mediaShareLinkFilters.styleCodes.length ? '' : 'selected'"
    >
      @if (mediaShareLinkFilters.styleCodes && mediaShareLinkFilters.styleCodes.length) {
        <div class="flex center hover" (click)="openStyleCodeFilterModal()">
          <b class="margin-right-smallest">Style Code:</b>
          @for (code of mediaShareLinkFilters.styleCodes; track code; let last = $last) {
            {{ code }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('styleCodes')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleCodeFilterModal()">
          Style Code
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!mediaShareLinkFilters.link ? '' : 'selected'">
      @if (mediaShareLinkFilters.link) {
        <div class="flex center hover" (click)="openLinkFilterModal()">
          <b class="margin-right-smallest">Link text contains:</b>
          {{ mediaShareLinkFilters.link }}
        </div>
        <mat-icon class="hover" (click)="cleanFilter('link')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openLinkFilterModal()">
          Link Text
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  <div class="margin-top-small">
    @if (mediaShareLinks && mediaShareLinks.items && mediaShareLinks.items.length) {
      <bt-paginator
        [pageNumber]="mediaShareLinks.currentPage"
        [pageSize]="mediaShareLinks.size"
        [totalNumber]="mediaShareLinks.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>

      <table class="desktop-only">
        <tr>
          <th class="t-hidden">Creation Date</th>
          <th>Styles</th>
          <th>Link</th>
          <th>Status</th>

          <th>Action</th>
        </tr>
        @for (item of mediaShareLinks.items; track item.id) {
          <tr>
            <td class="t-hidden">{{ item.creationDate | date: 'dd-MM-yyyy HH:mm' }}</td>
            <td>{{ getStylesLabel(item) }}</td>
            <td>
              <span>
                <span
                  class="unicode {{ item.enabled ? 'primary' : 'grey' }} hover bg-light-grey"
                  matTooltip="Open in a new window"
                  (click)="openLinkInANewWindow(getShareLink(item.id))"
                >
                  {{ getShareLink(item.id) }}
                </span>
                <i
                  class="hover margin-left-smallest fa-regular fa-copy small margin-right-smallest"
                  matTooltip="Click to copy"
                  (click)="copyShareLink(item.id)"
                ></i>
              </span>
            </td>
            <td>
              <span class="flex center wrap">
                @if (item.enabled) {
                  <span class="flex center bg-green radius padding-right-smallest padding-left-smallest white">
                    <div class="blinking-dot bg-white margin-right-smallest"></div>
                    Active
                  </span>
                } @else {
                  <span class="grey">Inactive</span>
                }
              </span>
            </td>

            <td class="nowrap">
              <div class="flex center gap">
                @if (item.enabled) {
                  <span class="hover flex center red" (click)="stopMediaShareLink(item)">
                    <i class="fa-solid fa-stop small margin-right-smallest"></i>
                    Stop sharing
                  </span>
                } @else {
                  <span class="hover primary flex center" (click)="reactiveMediaShareLink(item)">
                    <i class="fa-solid fa-rotate-left small margin-right-smallest"></i>
                    Reactivate
                  </span>
                }

                <span
                  class="margin-left-smallest hover primary flex center"
                  [routerLink]="['/company/media-share-link-detail', item.id]"
                >
                  <i class="fa-solid fa-eye small margin-right-smallest"></i>
                  View products
                </span>
                <span class="margin-left-smallest hover flex center red" (click)="deleteMediaShareLink(item)">
                  <i class="fa-solid fa-trash small margin-right-smallest"></i>
                  Remove
                </span>
              </div>
            </td>
          </tr>
        }
      </table>

      <div class="mobile-only flex column gap">
        @for (item of mediaShareLinks.items; track item.id) {
          <div class="border radius padding margin-bottom-small">
            <div class="flex column gap">
              <div class="flex column">
                <b>Link:</b>
                <span
                  class="hover primary pointer flex center margin-top-smallest"
                  matTooltip="Click to copy"
                  (click)="copyShareLink(item.id)"
                >
                  <i class="fa-regular fa-copy small margin-right-smallest"></i>
                  {{ getShareLink(item.id) }}
                </span>
              </div>
              <div class="flex center">
                <b class="margin-right-smallest">Active:</b>
                <mat-checkbox [checked]="item.enabled" [disabled]="true"></mat-checkbox>
              </div>
              <div>
                <b>Styles:</b>
                {{ getStylesLabel(item) }}
              </div>
              <div>
                <b>Creation Date:</b>
                {{ item.creationDate | date: 'dd-MM-yyyy' }}
              </div>
              <div class="flex end gap">
                <span class="hover primary flex center" [routerLink]="['/company/media-share-link-detail', item.id]">
                  <i class="fa-solid fa-eye small margin-right-smallest"></i>
                  Open
                </span>
                @if (item.enabled) {
                  <span class="hover flex center red" (click)="stopMediaShareLink(item)">
                    <i class="fa-solid fa-stop small margin-right-smallest"></i>
                    Stop sharing
                  </span>
                } @else {
                  <span class="hover primary flex center" (click)="reactiveMediaShareLink(item)">
                    <i class="fa-solid fa-rotate-left small margin-right-smallest"></i>
                    Reactivate
                  </span>
                }
                <span class="hover flex center red" (click)="deleteMediaShareLink(item)">
                  <i class="fa-solid fa-trash small margin-right-smallest"></i>
                  Remove
                </span>
              </div>
            </div>
          </div>
        }
      </div>

      <bt-paginator
        [pageNumber]="mediaShareLinks.currentPage"
        [pageSize]="mediaShareLinks.size"
        [totalNumber]="mediaShareLinks.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>
    }

    @if (mediaShareLinks.items.length == 0 && !loading) {
      <div class="flex center bg-light-grey padding-largest justify-center">
        <div class="flex column center gap">
          <i class="fa fa-search fa-2xl margin-bottom grey"></i>
          <span>No data found</span>
        </div>
      </div>
    }
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
